import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { relatedTo } from "@/data/calculators";

export default function RelatedCalcs({ slug }) {
    const items = relatedTo(slug, 4);
    return (
        <div className="rounded-xl border border-border bg-card p-6" data-testid="related-calcs">
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-4">
                Related calculators
            </div>
            <ul className="space-y-1">
                {items.map((c) => (
                    <li key={c.slug}>
                        <Link
                            to={`/calculator/${c.slug}`}
                            data-testid={`related-${c.slug}`}
                            className="group flex items-start justify-between gap-3 py-2.5 border-b border-border/60 last:border-0"
                        >
                            <span>
                                <span className="block text-[15px] font-medium text-primary group-hover:underline decoration-accent decoration-2 underline-offset-4">
                                    {c.title}
                                </span>
                                <span className="block text-xs text-muted-foreground mt-0.5 leading-snug">
                                    {c.description.slice(0, 70)}…
                                </span>
                            </span>
                            <ArrowUpRight className="w-4 h-4 mt-1 text-muted-foreground group-hover:text-accent flex-shrink-0" strokeWidth={1.5} />
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
